import http from '../http'

export default {
  getFarmerLimit: (id) => {
    return http.get(`/limit/farmer/${id}`)
  }
}
